import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  gap: ${({ gap }) => gap}px;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  justify-content: ${({ justifyContent }) => justifyContent ?? 'flex-start'};
  align-items: ${({ alignItems }) => alignItems ?? 'flex-start'};
`;
